module.exports = __webpack_public_path__ + "img/registration.813a6f2d.png";